// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HzBxV","modal":"Modal_modal__RajTW","popup":"Modal_popup__Earvw","followers":"Modal_followers__dFAzU"};